export default __webpack_public_path__ + "static/media/answer-blue.0add5a11.png";